import { atom } from 'nanostores';

export type CopilotOverlayId =
  | 'rxWizard'
  | 'labOrderWizard'
  | 'followUps'
  | 'dosespotAction'
  | 'priorAuthAction'
  | 'priorAuthCompletedRx'
  | 'aiDebug';

export const $copilotOverlayIds = atom<CopilotOverlayId[]>([]);

export function openCopilotOverlay(id: CopilotOverlayId) {
  const current = $copilotOverlayIds.get();
  const withoutId = current.filter((overlayId) => overlayId !== id);
  $copilotOverlayIds.set([...withoutId, id]);
}

export function closeCopilotOverlay(id?: CopilotOverlayId) {
  const current = $copilotOverlayIds.get();
  if (id !== undefined) {
    $copilotOverlayIds.set(current.filter((overlayId) => overlayId !== id));
    return;
  }
  if (current.length === 0) {
    return;
  }
  $copilotOverlayIds.set(current.slice(0, -1));
}
